import React, { useContext, useEffect, useState } from "react";
import Loader from "../../components/UI/Loader/Loader";
import { useUserContext } from "../../contexts/UserContext";
import PreviewTemplate from "./PreviewTemplate";
import SuccessAlert from "../UI/Alert/SuccessAlert";
import { saveTemplates, editTemplates } from "../../utils/APIs";
import { GlobalTemplateContext } from "../../contexts/GlobalTemplateContext";
import { useNavigate } from "react-router-dom";
import backwardArrow from '../../assets/icons/backward-arrow.svg';
import { useContentfulContext } from "../../contexts/ContentfulContext";

const CreateGlobalTemplate = () => {
  const { userData } = useUserContext();
  const navigate = useNavigate();
  const { selectedTemplateId, rawData, setSelectedTemplateId } =
    useContext(GlobalTemplateContext);
  const { enums, content } = useContentfulContext();

  const [loading, setLoading] = useState(false);
  const [templateError, setTemplateError] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [templateSuccess, setTemplateSuccess] = useState("");
  const [changesDetected, setChangesDetected] = useState(false);
  const [cssCode, setCssCode] = useState("");
  const [htmlCode, setHtmlCode] = useState("");
  const [jsonSchemaCode, setJsonSchemaCode] = useState("");
  const [jsonBSchemaCode, setJsonBSchemaCode] = useState("");
  const [configJsonCode, setConfigJsonCode] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [templateType, setTemplateType] = useState("");
  const [templatePlatform, setTemplatePlatform] = useState("");
  const [isLandscapeSupport, setIsLandscapeSupport] = useState(true);
  const [levels, setLevels] = useState([]);
  const [templateSource, setTemplateSource] = useState("");
  const [apiEndPoint, setApiEndPoint] = useState("");

  const [templateIconURL, setTemplateIconURL] = useState({ web_only: "", mobile_only: "" });
  const [templateName, setTemplateName] = useState(() => {
    if (selectedTemplateId.length > 0) {
      const newTemplate = rawData.filter((item) => item._id === selectedTemplateId);
      return newTemplate[0]?.name || "";
    }
    return "";
  });

  useEffect(() => {
    if (selectedTemplateId && Object.keys(selectedTemplate)?.length > 0) {
      if (
        JSON.stringify(cssCode) == JSON.stringify(selectedTemplate.css) &&
        JSON.stringify(htmlCode) == JSON.stringify(selectedTemplate.html) &&
        JSON.stringify(configJsonCode) == JSON.stringify(selectedTemplate.json) &&
        JSON.stringify(jsonSchemaCode) == JSON.stringify(selectedTemplate.json) &&
        templateName == selectedTemplate.name
      ) {
        setChangesDetected(false);
      } else {
        setChangesDetected(true);
      }
    }
  }, [
    cssCode,
    htmlCode,
    configJsonCode,
    templateName,
    selectedTemplateId,
    selectedTemplate,
    jsonSchemaCode
  ]);

  useEffect(() => {
    if (selectedTemplateId.length > 0) {
      const newTemplate = rawData.find((item) => item._id === selectedTemplateId);
      setSelectedTemplate(newTemplate || {});
      setLevels(newTemplate?.levels|| []);
    }
  }, [selectedTemplateId, rawData]);

  useEffect(() => {
    if (Object.keys(selectedTemplate).length > 0) {
      setCssCode(selectedTemplate?.css || "");
      setHtmlCode(selectedTemplate?.html || "");
      setConfigJsonCode(selectedTemplate?.config_json || "");
      setJsonSchemaCode(selectedTemplate?.json_schema || "");
      setTemplateType(selectedTemplate?.type || "");
      setTemplatePlatform(selectedTemplate?.platform)
      setIsLandscapeSupport(selectedTemplate?.landscape_support)
      setTemplateSource(selectedTemplate?.source || "");
      setApiEndPoint(selectedTemplate?.api_end_point || "");
    }
  }, [selectedTemplate]);

  const validateTemplateName = () => {
    if (!templateName.trim()) setTemplateError("Template name is required");
    else setTemplateError("");
  };

  const validateURL = () => {
    const trimmedURL = apiEndPoint.trim();
    try {
      new URL(trimmedURL);
      setTemplateError("");
      return true;
    } catch (e) {
      setTemplateError("Invalid URL");
      return false;
    }
  };

  const createTemplateHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        name: templateName,
        icon_url: templateIconURL,
        html: htmlCode,
        css: cssCode,
        type: templateType,
        platform: templatePlatform,
        landscape_support: isLandscapeSupport,
        source: templateSource,
        api_end_point: apiEndPoint,
        config_json: configJsonCode,
        json_schema: jsonSchemaCode,
        levels : levels
      };

      const result = await saveTemplates(
        userData?.token,
        userData?.selectedOrganization?.org_token,
        payload,
        "global"
      );
      setSelectedTemplateId(result.data._id);
      setSelectedTemplate(result.data);
      setSubmitError("");
      setTemplateSuccess("Global Template created successfully");
    } catch (error) {
      setSubmitError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
    } finally {
      setLoading(false);
    }
  };

  const editTemplateHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        name: templateName,
        icon_url: templateIconURL,
        html: htmlCode,
        css: cssCode,
        type: templateType,
        platform: templatePlatform,
        landscape_support: isLandscapeSupport,
        source: templateSource,
        api_end_point: apiEndPoint,
        config_json: configJsonCode,
        json_schema: templateSource === enums?.templateSources.api.id ? "{}" : jsonSchemaCode,
        levels
      };
      const result = await editTemplates(
        userData?.token,
        userData?.selectedOrganization?.org_token,
        selectedTemplateId,
        payload,
        "global"
      );
      setSelectedTemplate(result.data);
      setSubmitError("");
      setTemplateSuccess("Global Template updated successfully");
    } catch (error) {
      setSubmitError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
    } finally {
      setLoading(false);
    }
  };

  const saveTemplateHandler = () => {
    validateTemplateName();
    if (!templateError) {

      console.log("error>>>>>>>>>>>>>>>")
      if (selectedTemplateId.length > 0 && changesDetected) {
        editTemplateHandler();
      } else if (!selectedTemplateId.length) {
        createTemplateHandler();
      }
    }
  };

  return (
    <div>
      {loading && <Loader />}
      {templateSuccess && (
        <SuccessAlert disappearTime={5000}>{templateSuccess}</SuccessAlert>
      )}
      <div class="my-4 px-8 w-full">
        <a href="#" class="font-medium text-primary hover:underline flex items-center" onClick={(e) => {
          e.preventDefault();
          navigate("/admin/global-template/manage-global-templates")
        }}>
          <img src={backwardArrow} alt='' className='w-5 h-5 mr-2' /> {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.back_cta_text}
        </a>
      </div>
      <div className="flex flex-col w-full px-4 md:px-8">
        <PreviewTemplate
          templateName={templateName}
          setTemplateName={setTemplateName}
          templateIconURL={templateIconURL}
          setTemplateIconURL={setTemplateIconURL}
          cssCode={cssCode}
          htmlCode={htmlCode}
          setHtmlCode={setHtmlCode}
          setCssCode={setCssCode}
          configJsonCode={configJsonCode}
          setConfigJsonCode={setConfigJsonCode}
          selectedTemplate={selectedTemplate}
          validateTemplateName={validateTemplateName}
          templateError={templateError}
          submitError={submitError}
          saveTemplateHandler={saveTemplateHandler}
          selectedTemplateId={selectedTemplateId}
          jsonSchemaCode={jsonSchemaCode}
          setJsonSchemaCode={setJsonSchemaCode}
          jsonBSchemaCode={jsonBSchemaCode}
          setJsonBSchemaCode={setJsonBSchemaCode}
          templateType={templateType}
          setTemplateType={setTemplateType}
          levels={levels}
          setLevels={setLevels}
          templatePlatform={templatePlatform}
          setTemplatePlatform={setTemplatePlatform}
          isLandscapeSupport={isLandscapeSupport}
          setIsLandscapeSupport={setIsLandscapeSupport}
          templateSource={templateSource}
          setTemplateSource={setTemplateSource}
          apiEndPoint={apiEndPoint}
          setApiEndPoint={setApiEndPoint}
          validateURL={validateURL}
        />
      </div>
    </div>
  );
};

export default CreateGlobalTemplate;
